import { useSmartProp } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, RangeControl, ToggleControl } from '@wordpress/components';

export const Inspector = () => {
    const [reverseCols, setreverseCols] = useSmartProp('reverseCols');
    const [withMargin, setWithMargin] = useSmartProp('withMargin');
    const [imageSize, setImageSize] = useSmartProp('imageSize');

    return (
        <PanelBody title="Paramètres" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label="Inverser les colonnes"
                    checked={reverseCols}
                    onChange={(value) => setreverseCols(value)}
                />
            </PanelRow>
            <PanelRow>
                <ToggleControl label="Avec marge" checked={withMargin} onChange={(value) => setWithMargin(value)} />
            </PanelRow>
            <PanelRow>
                <RangeControl
                    label="Taille de l'image"
                    help="Largeur de l'image en pourcentage de la taille de l'écran"
                    value={imageSize}
                    onChange={(val) => setImageSize(parseInt(val))}
                    min={0}
                    max={100}
                />
            </PanelRow>
        </PanelBody>
    );
};

export default Inspector;
